if (!customElements.get('sticky-atc')) {
  customElements.define(
    'sticky-atc',
    class StickyAtc extends HTMLElement {
      connectedCallback() {
        this.sectionId = this.dataset.section;
        this.mainButton = this.getMainButton();
        if (!this.mainButton) return;
        this.stickyButton = this.querySelector('.sticky-atc__button');
        this.stickyButton.addEventListener('click', () => {
          const target = this.getMainButton();
          if (target && !target.disabled) target.click();
        });
        this.observeMainButton(this.mainButton);
        this.variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, () => {
          // DOM cene/dugmeta se azurira odmah posle eventa — sacekaj render
          setTimeout(() => this.syncState(), 200);
        });
      }

      disconnectedCallback() {
        if (this.observer) this.observer.disconnect();
        if (this.variantChangeUnsubscriber) this.variantChangeUnsubscriber();
      }

      getMainButton() {
        return document.getElementById(`ProductSubmitButton-${this.sectionId}`);
      }

      observeMainButton(button) {
        if (this.observer) this.observer.disconnect();
        this.observer = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            const scrolledPast = !entry.isIntersecting && entry.boundingClientRect.top < 0;
            this.classList.toggle('is-visible', scrolledPast);
          });
        });
        this.observer.observe(button);
      }

      syncState() {
        const currentButton = this.getMainButton();
        if (!currentButton) return;
        if (currentButton !== this.mainButton) {
          this.mainButton = currentButton;
          this.observeMainButton(currentButton);
        }
        const mainSpan = currentButton.querySelector('span');
        if (mainSpan) this.stickyButton.textContent = mainSpan.textContent.trim();
        this.stickyButton.toggleAttribute('disabled', currentButton.disabled);
        const priceContainer = document.getElementById(`price-${this.sectionId}`);
        if (!priceContainer) return;
        const onSale = priceContainer.querySelector('.price--on-sale');
        const priceEl = onSale
          ? priceContainer.querySelector('.price-item--sale')
          : priceContainer.querySelector('.price-item--regular');
        const target = this.querySelector('[data-sticky-price]');
        if (priceEl && target) target.textContent = priceEl.textContent.trim();
      }
    }
  );
}
